import {defineCustomElements as defineIgWebComponents} from "informationgrid-webcomponents/dist/loader/index";
import "./resources/style.scss"
import React                                           from 'react';
import './App.css';
import {GobesContextProvider}                          from "./context/GobesContextProvider";
import MainPage                                        from "./pages/MainPage";

defineIgWebComponents(window)

function App()
{
    return (
        <div className="App">
            <GobesContextProvider>
                <MainPage/>
            </GobesContextProvider>
        </div>
)
    ;
}

export default App;
